import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Line from './Line';
import { injectIntl } from 'react-intl';
import CheckboxWrapper from '../Parts/CheckboxWrapper';

const Record = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const checkboxChangeHandler = () => {
    props.updateRecordHandler(props.record.id, { selected: !props.selected });
  };
  useEffect(() => {
    if (props.selectedRecords.includes(props.record.id) && !props.selected) {
      props.updateRecordHandler(props.record.id, { selected: true });
    }
  }, []);
  const showCheckBox = props.selectableRowDisabled ? !props.selectableRowDisabled(props.record) : false;
  const disabled = props.disabledRule ? props.disabledRule(props.record) : false;
  return (
    <div className={`record ${props.selected ? 'selected' : ''}`} onClick={() => setIsExpanded(true)}>
      {props.selectable && showCheckBox && (
        <CheckboxWrapper disabled={disabled} selected={props.selected || false} handleClick={checkboxChangeHandler} />
      )}
      {props.selectable && !showCheckBox && <div style={{ width: '40px' }} />}
      <div className='record-innerWrapper'>
        <div className='record-header'>
          <span className={`company-name ${isExpanded ? '' : 'excerpt'}`}>{props.record[props.recordHeaderKey]}</span>
          {((props.selectable && showCheckBox) || props.showActions) && props.actions(props.record)}
        </div>
        {props.recordLines.map((recordLine) => (
          <Line
            key={recordLine.cell}
            label={recordLine.name}
            value={recordLine.cell ? recordLine.cell(props.record) : props.record[recordLine.selector]}
            isExpanded={isExpanded}
          />
        ))}
      </div>
    </div>
  );
};

Record.propTypes = {
  record: PropTypes.object.isRequired,
  recordLines: PropTypes.array.isRequired,
  recordHeaderKey: PropTypes.string.isRequired,
  actions: PropTypes.func.isRequired,
  showActions: PropTypes.bool,
  selectableRowDisabled: PropTypes.func,
  disabledRule: PropTypes.func,
  selected: PropTypes.bool,
  selectable: PropTypes.bool,
};

export default injectIntl(Record);
